import * as React from 'react';
import { useMarkToolbarButton, useMarkToolbarButtonState } from 'platejs/react';
import { ToolbarEditorButton } from 'src/components/ui/editor/ui/toolbar-editor';

export function MarkToolbarButton({ clear, nodeType, ...props }) {
  const state = useMarkToolbarButtonState({ clear, nodeType });
  const { props: buttonProps } = useMarkToolbarButton(state);

  return <ToolbarEditorButton {...props} {...buttonProps} />;
}
